<div *ngIf="generalService.serverInfo"
     [class.PDFMode]="generalService.PDFMode"
     [class.OneLiveMode]="generalService.serverInfo && generalService.serverInfo.oneLiveMode"
     class="app-container">

    <div class="loading-system"
         *ngIf="generalService.systemInitialized === false"
         [class.pointerEventsNone]="generalService.systemInitialized === true"
         [class.hidden]="generalService.systemInitialized === null">

        <ac-splash-screen [ready]="generalService.systemInitialized !== true"
                          [pageTitle]="'Loading, Please wait... ' + (generalService.loading | acFunc : loading)"
                          [logoTemplate]="logoTemplate"></ac-splash-screen>

        <ng-template #logoTemplate>
            <logo-display></logo-display>
        </ng-template>
    </div>

    <router-outlet></router-outlet>
</div>

